export default "__VITE_ASSET__17908264__"